import React, { useEffect, useState } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { CircularProgress, Grid } from '@material-ui/core'
import styles from './styles'
import { CoreButton } from 'src/components/core'
import { aiTextGenerator } from 'src/api/common'

const AIAssistant = props => {
  const { classes, prompt, handleReplaceText, handleAddTextBelow } = props
  const [loading, setLoading] = React.useState(true)
  const [response, setResponse] = React.useState()

  const fetchData = async () => {
    setLoading(true)

    const request = await aiTextGenerator(prompt)
    setLoading(false)
    setResponse(request.data.response)
  }

  useEffect(() => {
    fetchData()
  }, [prompt])

  return (
    <Grid container className={classes.root} gap={1}>
      <div className={classes.responseContainer}>
        {loading && (
          <>
            <CircularProgress size={16} />{' '}
            <p className={classes.loadingText}>AI is writing...</p>
          </>
        )}
        {!loading && (
          <div
            className={classes.responseText}
            dangerouslySetInnerHTML={{ __html: response }}
          />
        )}
      </div>

      <div className={classes.buttonContainer}>
        <CoreButton
          disabled={loading}
          variant="text"
          size="small"
          color="secondary"
          onClick={() => fetchData()}
        >
          Generate again
        </CoreButton>
        <CoreButton
          disabled={loading}
          variant="text"
          size="small"
          color="secondary"
          onClick={() => {
            handleAddTextBelow(response)
          }}
        >
          Insert below
        </CoreButton>
        <CoreButton
          disabled={loading}
          variant="contained"
          color="primary"
          size="small"
          onClick={() => {
            handleReplaceText(response)
          }}
        >
          Replace text
        </CoreButton>
      </div>
    </Grid>
  )
}

export default withStyles(styles, { withTheme: true })(AIAssistant)
